import React from 'react';
import { connect } from 'react-redux';
import cognitesdk from '@cognite/cognitesdk';
import firebase from 'firebase';
import { replace } from 'connected-react-router';
import queryString from 'query-string';
import jwtDecode from 'jwt-decode';
import mixpanel from 'mixpanel-browser';
import axios from 'axios';
import LoadingScreen from 'components/LoadingScreen';
import {
  authSuccess,
  authRequest,
  listenToFirebaseUser,
} from '../modules/auth';
import { setProject } from '../modules/project';

class AuthContainer extends React.PureComponent {
  state = {
    loading: true,
  };

  async componentDidMount() {
    const host = window.location.hostname.split('.');
    const project = 'akso';
    this.props.dispatch(setProject(project));
    cognitesdk.configure({ project });
    firebase.auth().onAuthStateChanged(this.onAuthStateChanged);
    this.props.dispatch(authRequest());
    const res = await cognitesdk.getLoginStatus();
    if (res.loggedIn) {
      const qs = queryString.parse(this.props.query);
      if (Object.keys(qs).length > 0) {
        localStorage.setItem(
          '__OPERATIONAL_INTELLIGENCE__JWT',
          qs.access_token
        );
      }
      const localJwt = localStorage.getItem('__OPERATIONAL_INTELLIGENCE__JWT');
      if (!localJwt) {
        return cognitesdk.loginWithRedirect();
      }
      let decodedJwt;
      try {
        decodedJwt = jwtDecode(localJwt);
      } catch (ex) {
        // Erroneous JWT token
        localStorage.removeItem('__OPERATIONAL_INTELLIGENCE__JWT');
        return cognitesdk.loginWithRedirect();
      }
      window.Raven.setUserContext({
        email: decodedJwt.unique_name,
      });
      try {
        const tokenResult = await this.loginWithFirebase(localJwt);
        const token = tokenResult.data;
        const data = await firebase.auth().signInWithCustomToken(token);
        const user = await firebase
          .database()
          .ref('users')
          .child(data.uid)
          .once('value');
        if (!user.exists()) {
          await firebase
            .database()
            .ref('users')
            .child(data.uid)
            .set({
              email: decodedJwt.unique_name,
            });
        }
        window.Intercom('boot', {
          app_id:
            process.env.NODE_ENV === 'production' ? 'isi0uhpd' : 'xipwp9ym',
          user_id: data.uid,
        });
        mixpanel.init('d997bffa64966f1275f7b0b3829e27cd');
        mixpanel.identify(data.uid);
        this.props.dispatch(listenToFirebaseUser(data.uid));
        this.props.dispatch(
          authSuccess({
            email: res.user,
            uid: data.uid,
          })
        );
        const newQs = { ...qs };
        delete newQs.access_token;
        delete newQs.id_token;
        setTimeout(
          () =>
            this.props.dispatch(
              replace({
                pathname: this.props.pathname,
                search: queryString.stringify(newQs),
              })
            ),
          100
        );
        this.stayLoggedInService();
      } catch (ex) {
        localStorage.removeItem('__OPERATIONAL_INTELLIGENCE__JWT');
        if (ex.response && ex.response.status === 400) {
          // Can not talk to auth endpoint
        } else {
          window.Raven.captureException(ex);
        }
        return cognitesdk.loginWithRedirect();
      }
    } else {
      return cognitesdk.loginWithRedirect();
    }
    this.setState({
      loading: false,
    });
  }

  componentDidUpdate({ pathname }) {
    if (pathname !== this.props.pathname) {
      window.Intercom('update');
    }
  }

  componentWillUnmount() {
    clearInterval(this.loginInterval);
  }

  onAuthStateChanged = () => {};

  loginWithFirebase = async jwt => {
    const url = 'https://localhost:8001/login/firebase/';
    return axios.get(url, {
      params: {
        token: jwt,
        app: 'opint-dev',
      },
    });
  };

  stayLoggedInService = () => {
    this.loginInterval = setInterval(async () => {
      const res = await cognitesdk.getLoginStatus();
      if (!res.loggedIn) {
        return cognitesdk.loginWithRedirect();
      }
    }, 15 * 60 * 1000); // Every 15 minutes.
  };

  render() {
    const { children } = this.props;
    const { loading } = this.state;
    if (loading) {
      return <LoadingScreen />;
    }
    return children;
  }
}

function mapStateToProps(state) {
  return {
    auth: state.auth,
    query: state.router.location.search,
    pathname: state.router.location.pathname,
    project: state.project,
  };
}

export default connect(mapStateToProps)(AuthContainer);



// WEBPACK FOOTER //
// ./src/containers/AuthContainer.js